import dayjs from 'dayjs';
import { OrderDirection } from 'app/types';
import PageMainContainer from 'app/modules/insights/modules/pagePerformance/components/PageMainContainer';
import React from 'react';
import PageMetricCardContentProvider from 'app/modules/insights/modules/pagePerformance/components/pageMetricCard/PageMetricCardContentProvider';
import PageMetricCardContentGraph from 'app/modules/insights/modules/pagePerformance/components/pageMetricCard/PageMetricCardCollapsedContent';
import BlockGrid from 'app/components/BlockGrid';
import PageMetricCardContent from 'app/modules/insights/modules/pagePerformance/components/pageMetricCard/PageMetricCardContent';
import {
  BEST_TIME_TO_POST_ALL,
  BEST_TIME_TO_POST_PERIOD,
  ENGAGEMENT_RATE,
  IMPRESSIONS,
  PAID_ORGANIC,
  PAID_VS_ORGANIC,
  POST_ENGAGEMENT,
  UNIQUE_IMPRESSIONS,
  VIRAL_VS_NON_VIRAL,
  VIRAL_VS_NON_VIRAL_UNIQUE,
} from 'app/modules/insights/components/demoViews/dummyPagePerformance';

const startDate = dayjs().startOf('month');
const endDate = dayjs();
const comparedStartDate = startDate.subtract(1, 'month');
const comparedEndDate = endDate.subtract(1, 'month');

const insightsState = {
  filterState: {
    selectedProfiles: ['1234567890'],
    orderDirection: OrderDirection.Desc,
    startDate,
    endDate,
    datePreset: null,
    selectedPostTypes: [],
    selectedMetric: 'all',
    comparedStartDate,
    comparedEndDate,
  },
};

const commonProps = {
  showTabs: false,
  onToggleExpandClick: () => null,
  filterState: insightsState.filterState,
  expanded: false,
  combinedMetricComparedData: [],
  isCombinedMetric: false,
};

const PagePerformanceDemoView = () => {
  return (
    <PageMainContainer>
      <h1 className="tw-mb-6 tw-text-lg tw-font-semibold">
        Page Performance (Demo)
      </h1>
      <div className="tw-flex tw-flex-col tw-gap-4">
        <BlockGrid gap={16} columns={1}>
          <PageMetricCardContent metric={ENGAGEMENT_RATE.metric} disableExpand>
            <PageMetricCardContentProvider
              useMeridianTime={false}
              metricCardData={ENGAGEMENT_RATE.metricData}
            >
              <PageMetricCardContentGraph
                {...commonProps}
                metricCardData={ENGAGEMENT_RATE.metricData}
                title={ENGAGEMENT_RATE.metric.title}
              />
            </PageMetricCardContentProvider>
          </PageMetricCardContent>
        </BlockGrid>
        <BlockGrid gap={16} columns={2}>
          <PageMetricCardContent
            metric={BEST_TIME_TO_POST_ALL.metric}
            disableExpand
          >
            <PageMetricCardContentProvider
              useMeridianTime={false}
              metricCardData={BEST_TIME_TO_POST_ALL.metricData}
            >
              <PageMetricCardContentGraph
                {...commonProps}
                metricCardData={BEST_TIME_TO_POST_ALL.metricData}
                title={BEST_TIME_TO_POST_ALL.metric.title}
              />
            </PageMetricCardContentProvider>
          </PageMetricCardContent>
          <PageMetricCardContent
            metric={BEST_TIME_TO_POST_PERIOD.metric}
            disableExpand
          >
            <PageMetricCardContentProvider
              useMeridianTime={false}
              metricCardData={BEST_TIME_TO_POST_PERIOD.metricData}
            >
              <PageMetricCardContentGraph
                {...commonProps}
                metricCardData={BEST_TIME_TO_POST_PERIOD.metricData}
                title={BEST_TIME_TO_POST_PERIOD.metric.title}
              />
            </PageMetricCardContentProvider>
          </PageMetricCardContent>
        </BlockGrid>
        <BlockGrid gap={16} columns={1}>
          <PageMetricCardContent metric={IMPRESSIONS.metric} disableExpand>
            <PageMetricCardContentProvider
              useMeridianTime={false}
              metricCardData={IMPRESSIONS.metricData}
            >
              <PageMetricCardContentGraph
                {...commonProps}
                metricCardData={IMPRESSIONS.metricData}
                title={IMPRESSIONS.metric.title}
              />
            </PageMetricCardContentProvider>
          </PageMetricCardContent>
        </BlockGrid>
        <BlockGrid gap={16} columns={3}>
          <PageMetricCardContent metric={POST_ENGAGEMENT.metric} disableExpand>
            <PageMetricCardContentProvider
              useMeridianTime={false}
              metricCardData={POST_ENGAGEMENT.metricData}
            >
              <PageMetricCardContentGraph
                {...commonProps}
                metricCardData={POST_ENGAGEMENT.metricData}
                title={POST_ENGAGEMENT.metric.title}
              />
            </PageMetricCardContentProvider>
          </PageMetricCardContent>
          <PageMetricCardContent
            metric={UNIQUE_IMPRESSIONS.metric}
            disableExpand
          >
            <PageMetricCardContentProvider
              useMeridianTime={false}
              metricCardData={UNIQUE_IMPRESSIONS.metricData}
            >
              <PageMetricCardContentGraph
                {...commonProps}
                metricCardData={UNIQUE_IMPRESSIONS.metricData}
                title={UNIQUE_IMPRESSIONS.metric.title}
              />
            </PageMetricCardContentProvider>
          </PageMetricCardContent>
          <PageMetricCardContent metric={PAID_VS_ORGANIC.metric} disableExpand>
            <PageMetricCardContentProvider
              useMeridianTime={false}
              metricCardData={PAID_VS_ORGANIC.metricData}
            >
              <PageMetricCardContentGraph
                {...commonProps}
                metricCardData={PAID_VS_ORGANIC.metricData}
                title={PAID_VS_ORGANIC.metric.title}
              />
            </PageMetricCardContentProvider>
          </PageMetricCardContent>
        </BlockGrid>
        <BlockGrid gap={16} columns={3}>
          <PageMetricCardContent
            metric={VIRAL_VS_NON_VIRAL.metric}
            disableExpand
          >
            <PageMetricCardContentProvider
              useMeridianTime={false}
              metricCardData={VIRAL_VS_NON_VIRAL.metricData}
            >
              <PageMetricCardContentGraph
                {...commonProps}
                metricCardData={VIRAL_VS_NON_VIRAL.metricData}
                title={VIRAL_VS_NON_VIRAL.metric.title}
              />
            </PageMetricCardContentProvider>
          </PageMetricCardContent>
          <PageMetricCardContent
            metric={VIRAL_VS_NON_VIRAL_UNIQUE.metric}
            disableExpand
          >
            <PageMetricCardContentProvider
              useMeridianTime={false}
              metricCardData={VIRAL_VS_NON_VIRAL_UNIQUE.metricData}
            >
              <PageMetricCardContentGraph
                {...commonProps}
                metricCardData={VIRAL_VS_NON_VIRAL_UNIQUE.metricData}
                title={VIRAL_VS_NON_VIRAL_UNIQUE.metric.title}
              />
            </PageMetricCardContentProvider>
          </PageMetricCardContent>
          <PageMetricCardContent metric={PAID_ORGANIC.metric} disableExpand>
            <PageMetricCardContentProvider
              useMeridianTime={false}
              metricCardData={PAID_ORGANIC.metricData}
            >
              <PageMetricCardContentGraph
                {...commonProps}
                metricCardData={PAID_ORGANIC.metricData}
                title={PAID_ORGANIC.metric.title}
              />
            </PageMetricCardContentProvider>
          </PageMetricCardContent>
        </BlockGrid>
      </div>
    </PageMainContainer>
  );
};

export default PagePerformanceDemoView;
